import { HotTable, HotColumn } from '@handsontable/vue';
import {
  settings as unrealizedSettings,
  structData as unrealizedStructData,
  columnMap as unrealizedColumnMap,
  sumMap as unrealizedSumMap,
  projectMap as unrealizedProjectMap,
  fundMap as unrealizedFundMap,
  precisionMap as unrealizedPrecisionMap
} from './unrealized.conf.js';
import {
  settings as unrealizedNewSettings,
  structData as unrealizedNewStructData,
  columnMap as unrealizedNewColumnMap,
  sumMap as unrealizedNewSumMap,
  projectMap as unrealizedNewProjectMap,
  fundMap as unrealizedNewFundMap,
  precisionMap as unrealizedNewPrecisionMap,
  colorMap as unrealizedNewColorMap,
  liteVersionMap as unrealizedNewLiteVersionMap
} from './unrealized.new.conf.js';
import {
  settings as realizedSettings,
  structData as realizedStructData,
  columnMap as realizedColumnMap,
  sumMap as realizedSumMap,
  projectMap as realizedProjectMap,
  fundMap as realizedFundMap,
  precisionMap as realizedPrecisionMap
} from './realized.conf.js';
import {
  settings as realizedNewSettings,
  structData as realizedNewStructData,
  columnMap as realizedNewColumnMap,
  sumMap as realizedNewSumMap,
  projectMap as realizedNewProjectMap,
  fundMap as realizedNewFundMap,
  precisionMap as realizedNewPrecisionMap,
  colorMap as realizedNewColorMap,
  liteVersionMap as realizedNewLiteVersionMap
} from './realized.new.conf.js';
import Event from '@/utils/event';
import fundMenu from './menu.vue';
import fundSummary from './summary.vue';
import { roundSimpleList, roundList } from '@/api/common';
import { queryFairDetail, compareVersion, modifyDetail } from '@/api/finance';
import { validator, unrealizedValidatorMap, realizedValidatorMap, requiredMap } from './validator.js';
import { summaryColumns, statusMap, financingStageMap, dealTypeMap, eventTypeMap, exitTypeMap, currencyMap, statusSummaryMap } from '@/utils/finance';
import { number } from 'echarts';
import { isArray } from 'lodash';
const dateMap = [
  'initialInvestmentDate',
  'initialInvestmentDate',
  'latestValuationDate',
  'deliveryDate',
  'buybackDeadline',
  'eventHappenDate',
  'eventEffectDate',
  'initialInvestmentDate',
  'proceedDate',
  'initialInvestmentDate',
  'investDeliveryDate',
  'investBuybackDeadline',
  'latestRoundFinancialDeliveryDate',
  'financialAdjustmentDate'
];
const isCurrencyMap = [
  'latestValuationCurrency',
  'currency',
  'originalValuationCurrency',
  'eventCurrency',
  'investCurrency',
  'investOriginalValuationCurrency',
  'latestRoundValuationCurrency',
  'financialAdjustmentCurrency'
];
const roundMap = [
  // unrealized
  'classOfShare', // 原名：Class of Share；改为：持股轮次
  'classOfShare', //本轮交易轮次
  'thisClassOfShareId', // 企业所处轮次
  'eventClassOfShareId', // 事件发生后
  // realized
  'investClassOfShareId',
  'investClassOfShare',
  'investThisClassOfShareId',
  'latestValuationRoundsId', // 估值调整伦次
  'latestRoundFinancingRoundId', // 最新融资轮次
  'valuationRounds'
];
const boolMap = ['isFivett', 'isSmes', 'latestFocusOnValuationCompany', 'isFinancialAdjustment'];
const enumMap = ['nodeType', 'nodeTypeRound', 'companyStatus'];

export default {
  props: {
    type: String
  },
  computed: {
    maxTagPlaceholderRealized() {
      if (this.selectedColumn['realized'].length === this.realizedTable.headers.length) {
        this.realizedTable.allSelect = 1;
        return '全选';
      } else if (this.selectedColumn['realized'].length === 0) {
        this.realizedTable.allSelect = 2;
        return '请选择';
      } else {
        this.realizedTable.allSelect = null;
        return '自定义';
      }
    },
    maxTagPlaceholderUnrealized() {
      console.log(this.selectedColumn['unrealized'].length, this.unrealizedTable.headers.length);
      if (this.selectedColumn['unrealized'].length === this.unrealizedTable.headers.length) {
        this.unrealizedTable.allSelect = 1;
        return '全选';
      } else if (this.selectedColumn['unrealized'].length === 0) {
        this.unrealizedTable.allSelect = 2;
        return '请选择';
      } else {
        this.unrealizedTable.allSelect = null;
        return '自定义';
      }
    },
    maxTagCountRealized() {
      return this.selectedColumn['realized'].length < 2 ? 1 : 0;
    },
    maxTagCountUnrealized() {
      return this.selectedColumn['unrealized'].length < 2 ? 1 : 0;
    }
  },
  data() {
    return {
      spinning: false,
      versionId: null,
      tableCurrency: null,
      summary: null,
      fundInvestProgress: null,
      fundInvestCurrentStatus: null,
      fundPerformanceIndicators: null,
      compareStatus: false,
      fundInfoFlag: null, // 0-旧版 1-旧版fmv+新版汇总 2-新版
      // unrealizedStructData 每一格的value
      // unrealizedSettings 包含了nestedHeaders,里面是表头
      unrealizedTable: {
        data: null,
        colMap: unrealizedColumnMap,
        allSelect: null,
        selectedColumn: unrealizedStructData[0].slice(1).map(ele => ele.index),
        settings: unrealizedSettings,
        structData: unrealizedStructData,
        headers: unrealizedStructData[0].slice(1), //第一列为固定列不能选择
        newLine: false
      },
      unrealizedOldTable: {
        data: null,
        colMap: unrealizedColumnMap,
        allSelect: null,
        selectedColumn: unrealizedStructData[0].slice(1).map(ele => ele.index),
        settings: unrealizedSettings,
        structData: unrealizedStructData,
        headers: unrealizedStructData[0].slice(1), //第一列为固定列不能选择
        newLine: false
      },
      unrealizedNewTable: {
        data: null,
        colMap: unrealizedNewColumnMap,
        allSelect: null,
        selectedColumn: unrealizedNewStructData[0].slice(1).map(ele => ele.index),
        settings: unrealizedNewSettings,
        structData: unrealizedNewStructData,
        headers: unrealizedNewStructData[0].slice(1), //第一列为固定列不能选择
        newLine: false
      },
      realizedTable: {
        data: null,
        colMap: realizedColumnMap,
        allSelect: null,
        selectedColumn: realizedStructData[0].slice(1).map(ele => ele.index),
        settings: realizedSettings,
        structData: realizedStructData,
        headers: realizedStructData[0].slice(1), //第一列为固定列不能选择
        newLine: false
      },
      realizedOldTable: {
        data: null,
        colMap: realizedColumnMap,
        allSelect: null,
        selectedColumn: realizedStructData[0].slice(1).map(ele => ele.index),
        settings: realizedSettings,
        structData: realizedStructData,
        headers: realizedStructData[0].slice(1), //第一列为固定列不能选择
        newLine: false
      },
      realizedNewTable: {
        data: null,
        colMap: realizedNewColumnMap,
        allSelect: null,
        selectedColumn: realizedNewStructData[0].slice(1).map(ele => ele.index),
        settings: realizedNewSettings,
        structData: realizedNewStructData,
        headers: realizedNewStructData[0].slice(2), //第一列为固定列不能选择
        newLine: false
      },
      unrealizedTableType: 2,
      realizedTableType: 2,
      editStatus: false,
      totalClassList: [],
      roundList: [],
      currencyMap,
      exitTypeMap,
      eventTypeMap,
      dealTypeMap: Object.fromEntries(
        [1,11, 41, 42, 43, 5].map(_ => {
          return [_, dealTypeMap[_]];
        })
      ),
      investDealTypeMap: Object.fromEntries(
        [1,11, 41, 42, 43, 5].map(_ => {
          return [_, dealTypeMap[_]];
        })
      ),
      companyStatusMap: statusSummaryMap,
      nodeTypeMap: {
        1: 'Initial',
        2: 'Follow-on'
      },
      nodeTypeRoundMap: {
        1: 'Initial',
        2: 'Follow-on'
      },
      selectedColumn: {
        unrealized: [],
        realized: []
      }
    };
  },
  components: {
    HotTable,
    HotColumn,
    fundMenu,
    fundSummary,
    selectAll: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  async created() {
    await this.fetchRoundList();
  },
  mounted() {
    let colorMap = unrealizedNewColorMap;
    let colorMap2 = realizedNewColorMap;

    // 根据表头配置的colorMap动态生成css样式表
    let style = document.createElement('style');
    style.innerHTML =
      colorMap
        .map((e, index) => {
          return `.new#hot-table-unrealized .htCore thead tr:nth-child(-n+2) th:nth-child(-n+${e.count}) { background-color: ${e.color}; }`;
        })
        .reverse()
        .join('\n') +
      colorMap2
        .map((e, index) => {
          return `.new#hot-table-realized .htCore thead tr:nth-child(-n+2) th:nth-child(-n+${e.count}) { background-color: ${e.color}; }`;
        })
        .reverse()
        .join('\n');
    document.head.appendChild(style);

    // 设置右键菜单&修改逻辑
    // this.initSetting('unrealized',1);
    // this.initSetting('realized',1);
    this.listenUpdateTable();
  },
  methods: {
    onChange(e) {
      console.log(e);
    },
    async queryFairDetail(versionId) {
      this.spinning = true;
      try {
        let res = await queryFairDetail({ versionId });
        this.spinning = false;
        Event.$emit('refreshMenu', res.data);
        return res;
      } catch (e) {}
      this.spinning = false;
      return null;
    },
    async fetchRoundList() {
      try {
        let res = (await roundSimpleList().then()) || {};
        // this.totalClassList = res.data ? res.data.map(_ => _.name) : [];
        this.totalClassList = res.data || [];
        let res2 = await roundList();
        this.roundList = res2.data || [];
      } catch (e) {}
    },
    validate(columnId, value, type) {
      const map = {
        unrealized: unrealizedValidatorMap,
        realized: realizedValidatorMap
      };
      const validatorName = map[type][columnId];

      if (validatorName) {
        if (validatorName === 'rounds') {
          return validator[validatorName](value, columnId, this.totalClassList);
        } else if (validatorName === 'enum') {
          return validator[validatorName](value, columnId, this[columnId + 'Map']);
        }
        return validator[validatorName](value, columnId);
      } else {
        return {
          msg: '',
          value: value,
          isValid: true
        };
      }
    },
    handleFairTableData(changeTable, res) {
      const data = res.data;
      this.fundInfoFlag = data.fundInfoFlag;
      this.allowBack = data.allowBack;
      this.realizedTable = this.fundInfoFlag > 1 ? this.realizedNewTable : this.realizedOldTable;
      this.unrealizedTable = this.fundInfoFlag > 1 ? this.unrealizedNewTable : this.unrealizedOldTable;

      this.initSetting('unrealized');
      this.initSetting('realized');

      this.realizedTable.data = data.exit && Object.keys(data.exit).length ? data.exit : null;
      this.realizedTable.newLine = false;
      this.unrealizedTable.data = data.notExit && Object.keys(data.notExit).length ? data.notExit : null;
      this.unrealizedTable.newLine = false;
      // this.realizedNewTable.data = Object.keys(data.exit).length ? data.exit : null;
      // this.realizedNewTable.newLine = false;
      this.summary = data.overAll;
      this.fundInvestProgress = data.fundInvestProgress;
      this.fundInvestCurrentStatus = data.fundInvestCurrentStatus;
      this.fundPerformanceIndicators = data.fundPerformanceIndicators;

      this.compareStatus = false;
      if (!changeTable || changeTable === 'unrealized') {
        this.renderTable('unrealized');
        setTimeout(() => {
          this.renderTable('realized');
        }, 1000);
      } else if (changeTable === 'realized') {
        this.renderTable('realized');
        setTimeout(() => {
          this.renderTable('unrealized');
        }, 1000);
      }
    },
    // // 保留小数点后两位
    // getNum() {

    // }
    listenUpdateTable() {
      Event.$on('visionRefresh', () => {
        // queryFairDetail({ versionId: this.versionId }).then(res => {
        //   this.handleFairTableData(null, res);
        // });
        console.log('visionRefresh');
        this.queryFairDetail(this.versionId).then(res => {
          this.handleFairTableData(null, res);
        });
      });
      Event.$on('refreshTable', msg => {
        console.log('refreshTable', msg);
        this.editStatus = false;
        let versionId = msg.versionId;
        let changeTable = msg.changeTable;
        if (msg.tableCurrency) {
          this.tableCurrency = msg.tableCurrency;
          unrealizedSettings.nestedHeaders[1].find(_ => _.key === 'otherCurrency').label =
            msg.tableCurrency === 'RMB' ? '项目估值（美元）' : '项目估值（人民币）';
        }
        this.versionId = versionId;
        this.selectedColumn = {
          unrealized: [],
          realized: []
        };
        if (this.fundInfoFlag === 2) {
          this.unrealizedTableType = 2;
          this.realizedTableType = 2;
        }
        // queryFairDetail({ versionId }).then(res => {
        //   this.handleFairTableData(changeTable, res);
        // });
        this.queryFairDetail(versionId).then(res => {
          this.handleFairTableData(changeTable, res);
        });
      });
      Event.$on('deactivateTable', () => {
        this.summary = null;
        this.fundInvestProgress = null;
        this.fundInvestCurrentStatus = null;
        this.fundPerformanceIndicators = null;
        this.fundInfoFlag = null;
        this.selectedColumn = {
          unrealized: [],
          realized: []
        };
        this.unrealizedTable = Object.assign(this.unrealizedTable, {
          data: null,
          newLine: false
        });
        this.realizedTable = Object.assign(this.realizedTable, {
          data: null,
          newLine: false
        });
      });
      Event.$on('menu-edit-save', msg => {
        if (msg.type === 'edit') {
          this.lockTable(false);
        } else if (msg.type === 'save') {
          this.lockTable(true);
        } else if (msg.type === 'new-version') {
          this.versionId = msg.versionId;
          this.lockTable(false);
        }
      });
      Event.$on('menu-compare', msg => {
        if (msg.compare) {
          this.spinning = true;
          compareVersion({
            versionId1: this.versionId,
            versionId2: msg.versionId
          })
            .then(res => {
              const data = res.data;
              this.realizedTable.data = data.exit;
              this.realizedTable.newLine = false;
              this.realizedNewTable.data = data.exit;
              this.unrealizedTable.data = data.notExit;
              this.unrealizedTable.newLine = false;
              this.unrealizedNewTable.data = data.notExit;
              this.summary = data.overAll;
              this.fundInvestProgress = data.fundInvestProgress;
              this.fundInvestCurrentStatus = data.fundInvestCurrentStatus;
              this.fundPerformanceIndicators = data.fundPerformanceIndicators;
              this.fundInfoFlag = data.fundInfoFlag1;
              this.compareTable(msg.compare);
              this.renderTable('unrealized');
              this.renderTable('realized');
            })
            .finally(() => {
              this.spinning = false;
            });
        } else {
          // queryFairDetail({ versionId: this.versionId }).then(res => {
          //   this.handleFairTableData(null, res);
          // });
          this.queryFairDetail(this.versionId).then(res => {
            this.handleFairTableData(null, res);
          });
          this.compareStatus = false;
          // this.compareTable(msg.compare);
          // this.renderTable('unrealized');
          // this.renderTable('realized');
        }
      });
    },
    // 设置右键菜单&修改逻辑
    initSetting(type) {
      console.log('initSetting', type);
      let settings;
      let tableData;
      let hotInstance;
      let structData;
      let liteVersionMap = [];
      if (type === 'unrealized') {
        tableData = this.unrealizedTable;
        hotInstance = this.$refs.unrealizedTable.hotInstance;
        liteVersionMap = unrealizedNewLiteVersionMap;
      } else if (type === 'realized') {
        tableData = this.realizedTable;
        hotInstance = this.$refs.realizedTable.hotInstance;
        liteVersionMap = realizedNewLiteVersionMap;
      }
      settings = tableData.settings;
      structData = tableData.structData[0];
      if (this.fundInfoFlag === 2) {
        if (this.selectedColumn[type] && this.selectedColumn[type].length) {
          // 按照选中的列初始化
          settings.hiddenColumns = {
            columns: structData
              .filter(_ => _.index && !this.selectedColumn[type].includes(_.index))
              .map(item => {
                return item.index;
              })
          };
        } else {
          // 初始化成精简
          settings.hiddenColumns = {
            columns: structData
              .filter(_ => !liteVersionMap.includes(_.index))
              .map(item => {
                return item.index;
              })
          };
          this.selectedColumn[type] = liteVersionMap;
        }
      } else {
        this.selectedColumn[type] = structData.slice(1).map(ele => ele.index);
      }

      settings.beforeChange = changes => {
        if (changes) {
          changes.forEach(([row, col, oldValue, newValue]) => {
            if (oldValue !== newValue) {
              const cellData = tableData.structData[row + 1][col];
              const validateResult = this.validate(tableData.colMap[col], newValue, type);
              if (validateResult.isValid) {
                cellData['value'] = validateResult.value;
                this.updateCell(row, col, type, 'update');
              } else {
                // queryFairDetail({ versionId: this.versionId }).then(res => {
                //   this.handleFairTableData(type, res);
                // });
                this.queryFairDetail(this.versionId).then(res => {
                  this.handleFairTableData(type, res);
                });
                this.$message.error(validateResult.msg);
              }
            }
          });
        }
      };
      settings.contextMenu = {
        items: {
          // fix: {
          //   name: '人工直接修改',
          //   disabled: () => {
          //     const row = hotInstance.getSelected()[0][0];
          //     const col = hotInstance.getSelected()[0][1];
          //     if (!this.editStatus || +tableData.structData[row + 1][col]['eleProperty'] !== 0) {
          //       //不是原始类型就禁用
          //       return true;
          //     } else {
          //       return false;
          //     }
          //   },
          //   callback: (operation, coords) => {
          //     const { row, col } = coords[0].start;
          //     this.updateCell(row, col, type, 'update');
          //   }
          // },
          toMiddle: {
            name: '去中间页修改',
            disabled: () => {
              // const row = hotInstance.getSelected()[0][0]
              // let type = tableData.structData[row + 1][0].type;
              // return type !== 'project';
            },
            callback: (operation, coords) => {
              const { row, col } = coords[0].start;
              let projectId = tableData.structData[row + 1][0].companyId;
              window.open(`/finance/middlePage/detail?projectId=${projectId}`);
            }
          },
          unfix: {
            name: '恢复关联财务中间页数据',
            disabled: () => {
              const row = hotInstance.getSelected()[0][0];
              const col = hotInstance.getSelected()[0][1];
              if (!this.editStatus || +tableData.structData[row + 1][col]['eleProperty'] !== 2) {
                //不是fix类型就禁用
                return true;
              } else {
                return false;
              }
            },
            callback: (operation, coords) => {
              const { row, col } = coords[0].start;
              this.updateCell(row, col, type, 'unfix');
            }
          },
          // addProject: {
          //   name: '新增项目',
          //   disabled: () => {
          //     const row = hotInstance.getSelected()[0][0];
          //     return !this.editStatus || row < 1 || tableData.newLine;
          //   },
          //   callback: (operation, coords) => {
          //     const { row, col } = coords[0].start;
          //     if (tableData.structData[row + 1][col].type === 'round' || tableData.structData[row + 1][col].type === 'project') {
          //       const row = Array(tableData.structData[0].length)
          //         .fill(null)
          //         .map(() => {
          //           return {
          //             eleProperty: 0,
          //             projectId: null,
          //             rowId: null,
          //             type: 'project',
          //             value: ''
          //           };
          //         });
          //       tableData.newLine = true;
          //       tableData.structData.push(row);
          //       this.genVirtualStyle(tableData.structData, type);
          //       tableData.settings.data.push(row.map(item => item.value));
          //     }
          //   }
          // },
          // addRound: {
          //   name: '新增轮次',
          //   disabled: () => {
          //     const row = hotInstance.getSelected()[0][0];
          //     console.log('新增轮次', !this.editStatus, row, tableData.newLine);
          //     return !this.editStatus || row < 2 || tableData.newLine;
          //   },
          //   callback: (operation, coords) => {
          //     const { row, col } = coords[0].start;
          //     if (tableData.structData[row + 1][col].type === 'round' || tableData.structData[row + 1][col].type === 'project') {
          //       const roundRow = Array(tableData.structData[0].length)
          //         .fill(null)
          //         .map(() => {
          //           return {
          //             eleProperty: 0,
          //             projectId: tableData.structData[row + 1][col]['projectId'],
          //             rowId: null,
          //             value: '',
          //             type: 'round'
          //           };
          //         });
          //       tableData.structData.splice(row + 2, 0, roundRow);
          //       this.genVirtualStyle(tableData.structData, type);
          //       tableData.settings.data.splice(
          //         row + 1, //
          //         0,
          //         roundRow.map(item => item.value)
          //       );
          //       tableData.newLine = true;
          //     }
          //   }
          // },
          delProject: {
            name: '删除项目',
            disabled: () => {
              const row = hotInstance.getSelected()[0][0];
              const col = hotInstance.getSelected()[0][1];
              return !this.editStatus || tableData.structData[row + 1][col]['type'] !== 'project';
            },
            callback: (operation, coords) => {
              const { row, col } = coords[0].start;
              const rowId = tableData.structData[row + 1][0]['rowId'];
              if (!rowId) {
                tableData.structData.splice(row + 1, 1);
                this.genVirtualStyle(tableData.structData, type);
                tableData.settings.data.splice(row, 1);
                tableData.newLine = false;
              } else {
                this.updateCell(row, 0, type, 'delete');
                // console.log("删除一个存在项目");
              }
            }
          },
          delRound: {
            name: '删除轮次',
            disabled: () => {
              const row = hotInstance.getSelected()[0][0];
              const col = hotInstance.getSelected()[0][1];
              return !this.editStatus || tableData.structData[row + 1][col]['type'] !== 'round';
            },
            callback: (operation, coords) => {
              const { row, col } = coords[0].start;
              if (!tableData.structData[row + 1][col]['rowId']) {
                tableData.structData.splice(row + 1, 1);
                this.genVirtualStyle(tableData.structData, type);
                tableData.settings.data.splice(row, 1);
                tableData.newLine = false;
              } else {
                this.updateCell(row, col, type, 'delete');
                // console.log("删除一个存在轮次");
              }
            }
          }
        }
      };
    },
    selectAll(type, all) {
      this.filterColumn(type, all);
    },
    filterColumn(type, all) {
      // type unrealized realized
      // all 1 全选 -1 全不选 2-精简版 3-自定义
      console.log('filterColumn', type, all);
      let tableData;
      let hotInstance;
      let liteVersionMap = [];
      if (type === 'unrealized') {
        tableData = this.unrealizedTable;
        hotInstance = this.$refs.unrealizedTable.hotInstance;
        liteVersionMap = unrealizedNewLiteVersionMap;
      } else if (type === 'realized') {
        tableData = this.realizedTable;
        hotInstance = this.$refs.realizedTable.hotInstance;
        liteVersionMap = realizedNewLiteVersionMap;
      }
      if (+all === 1) {
        this.selectedColumn[type] = tableData.headers.map(ele => ele.index);
      } else if (+all === -1) {
        this.selectedColumn[type] = [];
      } else if (+all === 2) {
        this.selectedColumn[type] = liteVersionMap;
      }
      const hiddenColumnsPlugin = hotInstance.getPlugin('hiddenColumns');
      hiddenColumnsPlugin.hideColumns(tableData.headers.map(ele => ele.index));
      hiddenColumnsPlugin.showColumns(this.selectedColumn[type]);
      hotInstance.render();
    },
    lockTable(lock) {
      // if (lock) {

      // }
      this.queryFairDetail(this.versionId).then(res => {
        // this.spinning = true;
        this.spinning = false;
        this.editStatus = !lock;
        this.handleFairTableData(null, res);
      });
    },
    compareTable(signal) {
      if (signal) {
        this.compareStatus = true;
      } else {
        this.compareStatus = false;
      }
      this.$refs.unrealizedTable.hotInstance.render();
      this.$refs.realizedTable.hotInstance.render();
    },
    // 生成虚拟样式
    genHTMLValue(item, col, type, key = 'value') {
      const map = {
        unrealized: this.fundInfoFlag > 1 ? unrealizedNewColumnMap : unrealizedColumnMap,
        // unrealized: unrealizedColumnMap,
        realized: this.fundInfoFlag > 1 ? realizedNewColumnMap : realizedColumnMap
      };
      const precisionMap = {
        unrealized: this.fundInfoFlag > 1 ? unrealizedNewPrecisionMap : unrealizedPrecisionMap,
        // unrealized: unrealizedPrecisionMap,
        realized: this.fundInfoFlag > 1 ? realizedNewPrecisionMap : realizedPrecisionMap
      };
      let value = item[key] + '';
      let result;
      //只有一个小数点
      let precisionFlag = 0;
      if (precisionMap[type]['twobit'].includes(map[type][col])) {
        precisionFlag = 2;
      } else if (precisionMap[type]['fourbit'].includes(map[type][col])) {
        precisionFlag = 4;
      }
      const reg = /\B(?=(\d{3})+(?!\d))/g;
      if (+precisionFlag === 2 || +precisionFlag === 4) {
        const percentage = /%/.test(value) ? '%' : '';
        try {
          result = parseFloat(value.replace(/,/g, '')).toFixed(precisionFlag);
          const numArr = result.split('.');
          result = numArr[0].replace(reg, ',') + '.' + numArr[1] + percentage;
        } catch (e) {
          result = value;
        }
      } else if (precisionFlag === 0) {
        let numberValue = +value.replace(/,/g, '');
        if ((numberValue || numberValue === 0) && map[type][col] !== 'valuationDate') {
          result = numberValue.toFixed(precisionFlag).replace(reg, ',');
        } else {
          result = value;
        }
      }
      return result;
    },
    // 生成虚拟表头样式
    genVirtualStyle(structData, type) {
      const backgroundStyle = ['rgb(224, 238, 208)', 'rgb(255, 234, 212)', 'rgb(210, 237, 254)', 'rgb(255, 218, 210)'];
      structData.forEach((rowItem, row) => {
        // 首行标题不作处理
        if (row) {
          rowItem.forEach((item, col) => {
            item.style = {};
            item.style.textAlign = structData[0][col].textAlign;
            item.style.verticalAlign = 'middle';
            item.style.fontWeight = 'bold';
            if (item.type === 'sum') {
              // flag=0的旧版表头颜色是固定写死的, 后面的新表头颜色是根据structureData中的background字段来的
              item.style.backgroundColor = this.fundInfoFlag > 1 ? structData[0][col].background : backgroundStyle[structData[0][col].background];
            } else if (item.type === 'project') {
              item.style.backgroundColor = 'rgb(246,245,245)';
            }
            item.style.borderRight = structData[0][col].border;
            if (!this.compareStatus) {
              if (item.value) {
                item.innerHTML = this.genHTMLValue(item, col, type);
                item.value = item.innerHTML;
              } else {
                item.innerHTML = '';
              }
              if (
                //fix
                item.eleProperty &&
                [2, 3].includes(item.eleProperty)
              ) {
                item.style.backgroundColor = 'rgb(252,238,238)';
              } else if (
                //计算值
                item.eleProperty &&
                +item.eleProperty === 1 &&
                item.value
              ) {
                item.style.color = '#3F51B5';
                // item.style.height = '30px';
              }
              item.style.height = `${(Math.ceil(structData[row][0].innerHTML.length / 7) || 1) * 30}px`;
            } else if (item.value || item.compareValue) {
              let _value = item.value ? this.genHTMLValue(item, col, type) : '-';
              let _compareValue = item.compareValue ? this.genHTMLValue(item, col, type, 'compareValue') : '-';
              let line = Math.ceil(_value.length / 15) + Math.ceil(_compareValue.length / 15);
              item.style.height = `${line * 30}px`;
              if (
                //计算值
                item.eleProperty &&
                +item.eleProperty === 1 &&
                item.value
              ) {
                _value = `<div style="color:#3F51B5">${_value}</div>`;
              } else {
                _value = `<div>${_value}</div>`;
              }
              if (+item.compareProperty !== 0) {
                _compareValue = `<div style="color:red">${_compareValue}</div>`;
              } else {
                _compareValue = _value;
              }
              item.innerHTML = `${_value}${_compareValue}`;
            } else {
              item.innerHTML = '';
            }
            // console.log('this.editStatus',this.editStatus, item.eleProperty);
            if (this.editStatus && [0, 2, 3].includes(item.eleProperty)) {
              // item.readOnly = true;
              item.readOnly = false;
            } else {
              item.readOnly = true;
            }
          });
        }
      });
    },
    genRows(type) {
      let tableData;
      let hotInstance;
      const allRows = [];
      let sumMap;
      let projectMap;
      let fundMap;
      if (type === 'unrealized') {
        tableData = this.fundInfoFlag > 1 ? this.unrealizedNewTable : this.unrealizedTable;
        hotInstance = this.$refs.unrealizedTable.hotInstance;
        sumMap = this.fundInfoFlag > 1 ? unrealizedNewSumMap : unrealizedSumMap;
        projectMap = this.fundInfoFlag > 1 ? unrealizedNewProjectMap : unrealizedProjectMap;
        fundMap = this.fundInfoFlag > 1 ? unrealizedNewFundMap : unrealizedFundMap;
      } else if (type === 'realized') {
        tableData = this.fundInfoFlag > 1 ? this.realizedNewTable : this.realizedTable;
        hotInstance = this.$refs.realizedTable.hotInstance;
        sumMap = this.fundInfoFlag > 1 ? realizedNewSumMap : realizedSumMap;
        projectMap = this.fundInfoFlag > 1 ? realizedNewProjectMap : realizedProjectMap;
        fundMap = this.fundInfoFlag > 1 ? realizedNewFundMap : realizedFundMap;
      }
      const detail = tableData.data;
      const rowLength = tableData.structData[0].length;
      /**sum */
      const sumRow = Array(rowLength)
        .fill(null)
        .map(() => {
          return { type: 'sum' };
        });
      for (let key in sumMap) {
        if (detail[key]) {
          // 报错
          sumRow[sumMap[key]] = {
            type: 'sum',
            value: detail[key]['value'],
            compareValue: detail[key]['compareValue'],
            eleProperty: detail[key]['eleProperty'],
            compareProperty: detail[key]['compareProperty']
          };
        }
      }
      allRows.push(sumRow);
      /**sum */

      /** 项目 */
      detail.projectList.forEach(project => {
        (project.id = project['portFolio']['rowId'] || 'projectId'), (project.companyId = project['projectId']['value']);
        const projectRow = Array(rowLength)
          .fill(null)
          .map(() => {
            return {
              type: 'project',
              projectId: project.id,
              rowId: project.rowId,
              companyId: project.companyId
            };
          });
        for (let key in projectMap) {
          if (project[key]) {
            let valueTmp = project[key]['value'];
            let compareValueTmp = project[key]['compareValue'];
            // 把轮次id改成名字
            if (roundMap.indexOf(key) > -1) {
              valueTmp = this.changeRound(project[key]['value'] + '', 0);
              compareValueTmp = this.changeRound(project[key]['compareValue'] + '', 0);
            } else if (boolMap.includes(key)) {
              // 是否522、是否中小企业
              valueTmp = project[key]['value'] === 1 ? '是' : project[key]['value'] === 0 ? '否' : '';
              compareValueTmp = project[key]['compareValue'] === 1 ? '是' : project[key]['compareValue'] === 0 ? '否' : '';
            } else if (enumMap.includes(key) && project[key]) {
              // 项目状态 & Initial/Follow-on
              valueTmp = this[key + 'Map'][project[key]['value']];
              compareValueTmp = this[key + 'Map'][project[key]['compareValue']];
            } else if (isCurrencyMap.includes(key)) {
              // 币种 latestValuationCurrency currency originalValuationCurrency eventCurrency
              valueTmp = this.currencyMap[project[key]['value']];
              compareValueTmp = this.currencyMap[project[key]['compareValue']];
            } else if (dateMap.includes(key)) {
              // 把时间YYYY.MM.DD改成YYYY/MM/DD
              valueTmp = project[key]['value'] ? project[key]['value'].replace(/\./g, '/') : '';
              compareValueTmp = project[key]['compareValue'] ? project[key]['compareValue'].replace(/\./g, '/') : '';
            }
            if (key !== 'fundList') {
              projectRow[projectMap[key]] = {
                eleProperty: project[key]['eleProperty'],
                compareProperty: project[key]['compareProperty'],
                type: 'project',
                projectId: project.id,
                rowId: project[key]['rowId'],
                value: valueTmp,
                compareValue: compareValueTmp,
                border: -1,
                companyId: project.companyId
              };
            }
          }
        }
        allRows.push(projectRow);

        /** 轮次 */
        project.fundList.forEach(fundItem => {
          fundItem.id = fundItem['classOfShare']['rowId'];
          const fundItemRow = Array(rowLength)
            .fill(null)
            .map(() => {
              return {
                rowId: fundItem.id,
                projectId: project.id,
                type: 'round',
                companyId: project.companyId
              };
            });
          for (let key in fundMap) {
            let valueTmp = '';
            let compareValueTmp = '';
            if (roundMap.indexOf(key) > -1 && fundItem[key]) {
              // 把轮次id改成名字
              valueTmp = this.changeRound(fundItem[key].value + '', 0);
              compareValueTmp = this.changeRound(fundItem[key].compareValue + '', 0);
            } else if (boolMap.includes(key)) {
              valueTmp = fundItem[key]['value'] === 1 ? '是' : fundItem[key]['value'] === 0 ? '否' : '';
              compareValueTmp = fundItem[key]['compareValue'] === 1 ? '是' : fundItem[key]['compareValue'] === 0 ? '否' : '';
            } else if (enumMap.includes(key) && fundItem[key]) {
              // 项目状态 & Initial/Follow-on
              valueTmp = this[key + 'Map'][fundItem[key]['value']];
              compareValueTmp = this[key + 'Map'][fundItem[key]['compareValue']];
            } else if (isCurrencyMap.indexOf(key) > -1 && fundItem[key]) {
              valueTmp = this.currencyMap[fundItem[key].value];
              compareValueTmp = this.currencyMap[fundItem[key].compareValue];
            } else if (key === 'exitType' && fundItem[key]) {
              valueTmp = this.exitTypeMap[fundItem[key].value];
              compareValueTmp = this.exitTypeMap[fundItem[key].compareValue];
            } else if ((key === 'dealType' || key === 'investDealType') && fundItem[key]) {
              valueTmp = this.dealTypeMap[fundItem[key].value];
              compareValueTmp = this.dealTypeMap[fundItem[key].compareValue];
            } else if (key === 'eventType' && fundItem[key]) {
              valueTmp = this.eventTypeMap[fundItem[key].value];
              compareValueTmp = this.eventTypeMap[fundItem[key].compareValue];
            } else if (dateMap.includes(key) && fundItem[key]) {
              valueTmp = fundItem[key].value ? fundItem[key].value.replace(/\./g, '/') : '';
              compareValueTmp = fundItem[key].compareValue ? fundItem[key].compareValue.replace(/\./g, '/') : '';
            } else if (fundItem[key]) {
              valueTmp = fundItem[key].value;
              compareValueTmp = fundItem[key].compareValue;
            }
            fundMap[key] = isArray(fundMap[key]) ? fundMap[key] : [fundMap[key]];
            if (fundItem[key]) {
              fundMap[key].forEach(item => {
                fundItemRow[item] = {
                  type: 'round',
                  rowId: fundItem[key]['rowId'],
                  projectId: project.id,
                  value: valueTmp,
                  compareValue: compareValueTmp,
                  eleProperty: fundItem[key].eleProperty,
                  compareProperty: fundItem[key].compareProperty,
                  companyId: project.companyId
                };
              });
            }
          }
          allRows.push(fundItemRow);
        });
        /** 轮次 */
      });
      /** 项目 */

      const renderData = [];
      console.log('allRows', allRows);
      allRows.forEach(row => {
        tableData.structData.push(row);
        renderData.push(
          row.map((item, col) => {
            let value = item.value === null || item.value === undefined ? '' : item.value + '';
            const map = {
              unrealized: unrealizedValidatorMap,
              realized: realizedValidatorMap
            };
            const columnId = tableData['colMap'][col];
            const validatorName = map[type][columnId];
            if (validatorName === 'number') {
              value = value.replace(/,/g, '');
            }
            return value;
          })
        );
      });
      this.genVirtualStyle(tableData.structData, type);
      tableData.settings.data = tableData.settings.data.concat(renderData);
      setTimeout(() => {
        hotInstance.updateSettings({
          fixedColumnsLeft: this.fundInfoFlag === 2 ? 3 : 1
        });
      }, 1000);
    },
    renderTable(type) {
      // 看fundInfoFlag 0-旧版 1-新版
      let tableData;
      let fundInfoFlag = this.fundInfoFlag;
      if (type === 'unrealized') {
        tableData = fundInfoFlag >= 2 ? this.unrealizedNewTable : this.unrealizedTable;
      } else if (type === 'realized') {
        tableData = fundInfoFlag >= 2 ? this.realizedNewTable : this.realizedTable;
      }
      console.log('type=', type, 'fundInfoFlag', fundInfoFlag, ',tableData=', tableData);
      if (tableData.data) {
        tableData.settings.data.length = 0;
        tableData.structData.length = 1;
        this.genRows(type);
      }
    },
    touchSelect() {},
    changeRound(key, type) {
      if (type === 0) {
        // 初始化从id拿name
        // roundList里的id是number,totalClassList里的id是字符串
        let tmp = this.roundList.find(_ => _.id === +key);
        return tmp ? tmp.name : '';
      } else if (type === 1) {
        // 提交修改从name拿id
        let tmp = this.totalClassList.find(e => e.name === key);
        return tmp ? tmp.id : '';
      }
      return '';
    },

    /**
     * 更新单元格的几种情况：
     * common：versionId，仅允许一行新建行
     * 0、更新轮次信息，rowId、columnId
     * 1、更新项目信息，projectId，columnId
     * 2、新建轮次信息，projectId，columnId
     * 3、新建项目信息，colunmId，（projectId为null）
     * 4、删除轮次信息，rowId
     * 5、删除项目信息，projectId
     * 6、取消轮次fix，rowId、columnId
     * 7、取消项目fix，projectId、columnId
     */
    updateCell(row, col, tableType, operationType) {
      let tableData;
      let hotInstance;
      const typeMap = {
        unrealized: 0,
        realized: 1
      };
      const modifyBody = {
        content: null,
        projectId: null,
        rowId: null,
        columnId: null,
        type: null, //0,1,2,3,4,5
        versionId: this.versionId,
        companyType: typeMap[tableType]
      };
      if (tableType === 'unrealized') {
        tableData = this.unrealizedTable;
        hotInstance = this.$refs.unrealizedTable.hotInstance;
      } else if (tableType === 'realized') {
        tableData = this.realizedTable;
        hotInstance = this.$refs.realizedTable.hotInstance;
      }
      const cellData = tableData.structData[row + 1][col];
      if (operationType === 'delete' && cellData['type'] === 'project') {
        //删除项目
        modifyBody.type = 5;
        modifyBody.projectId = cellData['rowId'];
      } else if (operationType === 'delete' && cellData['type'] === 'round') {
        //删除轮次
        modifyBody.type = 4;
        modifyBody.rowId = cellData['rowId'];
      } else if (operationType === 'update' && !cellData['projectId']) {
        //新建项目
        modifyBody.type = 3;
        modifyBody.columnId = tableData.colMap[col];
        modifyBody.content = cellData['value'];
      } else if (operationType === 'update' && !cellData['rowId']) {
        //新建轮次
        modifyBody.type = 2;
        modifyBody.projectId = cellData['projectId'];
        modifyBody.columnId = tableData.colMap[col];
        modifyBody.content = cellData['value'];
      } else if (operationType === 'update' && cellData['type'] === 'project') {
        //更新项目
        let key = tableData.colMap[col];
        modifyBody.content = cellData['value'];
        if (roundMap.indexOf(key) > -1) {
          modifyBody.content = this.changeRound(cellData['value'], 1);
        } else if (boolMap.includes(key)) {
          // 是否522、是否中小企业
          modifyBody.content = cellData['value'] === '是' ? 1 : cellData['value'] === '否' ? 0 : cellData['value'];
        } else if (enumMap.includes(key)) {
          // 项目状态 & Initial/Follow-on
          modifyBody.content = this[key + 'Map'][cellData['value']];
          let tmp = Object.keys(this[key + 'Map']).find(_ => this[key + 'Map'][_] === cellData['value']);
          modifyBody.content = tmp ? tmp : cellData['value'];
        } else if (key === 'latestValuationCurrency' || key === 'currency' || key === 'originalValuationCurrency' || key === 'eventCurrency') {
          // 币种
          modifyBody.content = this.currencyMap[cellData['value']];
          let tmp = Object.keys(this.currencyMap).find(key => this.currencyMap[key] === cellData['value']);
          modifyBody.content = tmp ? tmp : cellData['value'];
        } else if (dateMap.includes(key)) {
          // 把事件从YYYY/MM/DD转换成YYYY.MM.DD
          modifyBody.content = cellData['value'] ? cellData['value'].replace(/\//g, '.') : '';
        }
        modifyBody.type = 1;
        modifyBody.projectId = cellData['projectId'];
        modifyBody.columnId = tableData.colMap[col];
      } else if (operationType === 'update' && cellData['type'] === 'round') {
        //更新轮次
        //如果改的是classOfShare和valuationRounds,需要特殊处理.
        let key = tableData.colMap[col];
        if (roundMap.indexOf(key) > -1) {
          modifyBody.content = this.changeRound(cellData['value'], 1);
        } else if (boolMap.includes(key)) {
          modifyBody.content = cellData['value'] === '是' ? 1 : cellData['value'] === '否' ? 0 : cellData['value'];
        } else if (enumMap.includes(key)) {
          modifyBody.content = this[key + 'Map'][cellData['value']];
          let tmp = Object.keys(this[key + 'Map']).find(_ => this[key + 'Map'][_] === cellData['value']);
          modifyBody.content = tmp ? tmp : cellData['value'];
        } else if (isCurrencyMap.indexOf(key) > -1) {
          modifyBody.content = this.currencyMap[cellData['value']];
          let tmp = Object.keys(this.currencyMap).find(key => this.currencyMap[key] === cellData['value']);
          modifyBody.content = tmp ? tmp : cellData['value'];
        } else if (dateMap.includes(key)) {
          // 把事件从YYYY/MM/DD转换成YYYY.MM.DD
          modifyBody.content = cellData['value'] ? cellData['value'].replace(/\//g, '.') : '';
        } else if (key === 'exitType') {
          modifyBody.content = Object.keys(this.exitTypeMap).find(key => this.exitTypeMap[key] === cellData['value']);
        } else if (key === 'dealType' || key === 'investDealType') {
          modifyBody.content = Object.keys(this.dealTypeMap).find(key => this.dealTypeMap[key] === cellData['value']);
        } else if (key === 'eventType') {
          modifyBody.content = Object.keys(this.eventTypeMap).find(key => this.eventTypeMap[key] === cellData['value']);
        } else {
          modifyBody.content = cellData['value'];
        }
        modifyBody.type = 0;
        modifyBody.rowId = cellData['rowId'];
        modifyBody.columnId = tableData.colMap[col];
      } else if (operationType === 'unfix' && cellData['type'] === 'project') {
        modifyBody.type = 7;
        modifyBody.projectId = cellData['projectId'];
        modifyBody.columnId = tableData.colMap[col];
      } else if (operationType === 'unfix' && cellData['type'] === 'round') {
        modifyBody.type = 6;
        modifyBody.rowId = cellData['rowId'];
        modifyBody.columnId = tableData.colMap[col];
      }
      // this.spinning = true;
      modifyDetail(modifyBody)
        .then(res => {
          if (res.code === 200) {
            this.handleFairTableData(tableType, res);
          }
        })
        .finally(() => {
          // this.spinning = false;
        });
      // hotInstance.updateSettings({
      //   fixedColumnsLeft: undefined
      // });
    }
  }
};
